export const GMap = {
	name: 'GMap',
	props: {
		zoom: {
			type: Number,
			default: 16
		},
		loader: {
			type: Object,
			default: null
		},
	},
	data() {
		return {
			bounds: null,
			map: null,
		};
	},
	mounted() {
		this.$on("add-bounds", this.addBounds);

		this.bounds = new this.loader.maps.LatLngBounds();

		this.map = new this.loader.maps.Map(this.$refs.googleMap, {
			zoom: this.zoom,
			mapType: this.loader.maps.MapTypeId.ROADMAP,
		});
	},
	methods: {
		addBounds({ lat, lng }) {
			this.bounds.extend({
				lat: lat,
				lng: lng,
			});
			this.centerMap();
		},
		centerMap() {
			if (this.$slots.default.length === 1) {
				this.map.setCenter(this.bounds.getCenter());
			} else {
				this.map.fitBounds(this.bounds, (this.zoom / 16) * 75);
			}
		},
	},
	template: `
		<div class="acf-map" ref="googleMap">
			<slot v-if="map"></slot>
		</div>
	`
}
